import {
  LoaderSpinner,
  Modal,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { GiftCard } from '@vend/types'
import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { OmniGiftCardSettings } from '../../../controllers/gift-cards/balances-gift-cards'
import { useRetrieveRetailerGiftCardSettings } from '../hooks'
import { GiftCardSearch } from './GiftCardSearch'

// Migrated from workflows in wr-gift-cards.ts
export type GiftCardModalFlow =
  | 'SELLING' // For selling a new gift card
  | 'REDEEMING' // For redeeming an existing gift card to pay for a sale

// Migrated from states in wr-gift-cards.ts
export type GiftCardModalState =
  | 'SEARCH'
  | 'SET_VALUE'
  | 'VIEW_DETAILS'
  | 'ADD_BALANCE'
  | 'SERVER_ERROR'
  | 'LOADING'

// Migrated from GIFTCARD_PROVIDER_SETTINGS
export type GiftCardType =
  | 'BALANCES' // X-series gift card
  | 'BIGCOMMERCE' // BigCommerce gift certificate, only possible when redeeming

interface Props {
  giftCardType: GiftCardType
  flow: GiftCardModalFlow
  onClose: () => void
}

export const GiftCardModal: React.FC<Props> = ({
  giftCardType,
  flow,
  onClose,
}) => {
  const [state, setState] = useState<GiftCardModalState>('LOADING')
  const [
    giftCardSettings,
    setGiftCardSettings,
  ] = useState<OmniGiftCardSettings | null>(null)
  const [giftCard, setGiftCard] = useState<GiftCard | null>(null)

  const retrieveRetailerGiftCardSettings = useRetrieveRetailerGiftCardSettings(
    flow,
    onClose
  )

  useEffect(() => {
    const fetchSettings = async () => {
      const settings = await retrieveRetailerGiftCardSettings()
      setGiftCardSettings(settings)
      setState('SEARCH')
    }

    fetchSettings()
  }, [retrieveRetailerGiftCardSettings])

  return createPortal(
    <Modal size="medium" onClose={onClose}>
      {(() => {
        switch (state) {
          case 'SEARCH':
            return (
              <GiftCardSearch
                flow={flow}
                giftCardType={giftCardType}
                giftCardSettings={giftCardSettings}
                setGiftCard={setGiftCard}
                setState={setState}
                onClose={onClose}
              />
            )
          case 'SET_VALUE':
            // TODO: Implement properly
            return (
              <>
                <ModalHeader>SET_VALUE_PLACEHOLDER</ModalHeader>
                <ModalContent>
                  {giftCard ? JSON.stringify(giftCard) : null}
                </ModalContent>
              </>
            )
          case 'VIEW_DETAILS':
            return <div /> // TODO: /gift-cards/partials/details.html
          case 'ADD_BALANCE':
            return <div /> // TODO: /gift-cards/partials/add-balance.html
          case 'SERVER_ERROR':
            return <div /> // TODO: /gift-cards/partials/server-error.html
          case 'LOADING':
            return (
              <div className="vd-flex vd-flex--justify-center vd-flex--align-center">
                <LoaderSpinner />
              </div>
            )
        }
      })()}
    </Modal>,
    document.body
  )
}
